import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class VerifyIcon extends BaseIcon {

  getChildren = () => {
    const color = this.getColor() === 'currentColor' ? '#2e3f58' : this.getColor()
    return [
      <path
          d="M0 8a8.01 8.01 0 0 1 8-8 8 8 0 0 1 5.195 1.921l-1.466 1.382A5.928 5.928 0 0 0 8 2a6.005 6.005 0 0 0-6 6 6.005 6.005 0 0 0 6 6 6.006 6.006 0 0 0 6-6 6 6 0 0 0-.091-1.049l1.652-1.571A7.968 7.968 0 0 1 16 8a8.011 8.011 0 0 1-8 8 8.01 8.01 0 0 1-8-8Zm4-1.2 1.5-1.5L8.2 8 16.358.314l1.5 1.5L8.2 11Z"
          fill={color}/>
    ]
  }
  getViewBox = () => '0 0 17.859 16.001'
}
